export function getValueByPath(obj, path) {
    var paths = path.split('.');
    var o = obj;
    while (paths.length > 0) {
        var p = paths.shift();
        if (typeof o !== 'object') {
            throw new Error('invalid path: ' + path);
        }
        o = o[p];
    }
    return o;
}
export function setValueByPath(obj, path, value) {
    var paths = path.split('.');
    var o = obj;
    while (paths.length > 0) {
        var p = paths.shift();
        if (o === undefined)
            o = {};
        if (o === null || typeof o === 'number' || typeof o === 'boolean') {
            throw new Error('invalid path: ' + path);
        }
        if (paths.length === 0) {
            o[p] = value;
        }
        else {
            o = o[p];
        }
    }
}
